import React from "react";
import BSAccordion from "react-bootstrap/Accordion";
import { connect } from "react-redux";

import CMSContent from "../../CMSContent/index.jsx";
import AddGoalForm from "./AddGoalForm.jsx";
import GoalsList from "./GoalsList.jsx";

import { isLoading } from "@scripts/utilities/redux-helpers.js";
import {
  completeGoal,
  deleteDashboardGoal,
  getUserPreferences,
  setDashboardGoal,
} from "../../../Store/user-preferences.js";

class Goals extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showAddForm: false,
      isExpanded: true,
    };
  }

  toggleAccordion() {
    this.setState({ isExpanded: !this.state.isExpanded });
  }

  toggleAddForm() {
    this.setState({ showAddForm: !this.state.showAddForm });
  }

  getAllPortfoliosWithGoals() {
    const { goals, portfolios } = this.props;

    const allPortfolios = [
      {
        id: null,
        name: "Overall Goals",
        isGlobal: true,
      },
      ...portfolios,
    ];

    return allPortfolios
      .map((portfolio) => ({
        ...portfolio,
        goals: goals.filter((goal) => String(goal.portfolio_id) === String(portfolio.id)),
      }))
      .filter((portfolio) => portfolio.goals.length > 0);
  }

  renderContent() {
    if (this.props.loading) {
      return (
        <div className="text-center my-4">
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      );
    }

    const portfoliosWithGoals = this.getAllPortfoliosWithGoals();
    const { portfolios } = this.props;

    return (
      <CMSContent>
        <p>
          Please read our guide{" "}
          <a
            href="https://collectiveshift.io/wp-content/uploads/2025/03/10-Step-Strategy-Template-Platinum.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            here
          </a>
          .
        </p>

        {portfoliosWithGoals.map((portfolio) => (
          <div key={portfolio.id || "overall"} className="cs-goals__section">
            <h3>{portfolio.name}</h3>
            <GoalsList
              goals={portfolio.goals}
              onEdit={this.props.setDashboardGoal}
              onDelete={this.props.deleteDashboardGoal}
              onComplete={this.props.completeGoal}
            />
          </div>
        ))}

        {this.state.showAddForm ? (
          <AddGoalForm
            portfolios={portfolios}
            onSave={(goal) => {
              this.props.setDashboardGoal(goal);
              this.toggleAddForm();
            }}
            onCancel={() => this.toggleAddForm()}
          />
        ) : (
          <div className="text-left mt-3">
            <button className="btn btn-dark" onClick={() => this.toggleAddForm()}>
              Add Goal
            </button>
          </div>
        )}
      </CMSContent>
    );
  }

  render() {
    return (
      <div className="cs-goals">
        <BSAccordion className="cs-accordion" activeKey={this.state.isExpanded ? "goals-accordion" : undefined}>
          <BSAccordion.Toggle
            eventKey="goals-accordion"
            className="cs-accordion__toggle"
            onClick={() => this.toggleAccordion()}
            aria-expanded={this.state.isExpanded.toString()}
          >
            <h3 className="m-0">Goals</h3>
          </BSAccordion.Toggle>
          <BSAccordion.Collapse eventKey="goals-accordion">
            <div className="cs-accordion__content">{this.renderContent()}</div>
          </BSAccordion.Collapse>
        </BSAccordion>
      </div>
    );
  }
}

const mapStateToProps = function (state) {
  const userPreferences = getUserPreferences(state);
  const loading = isLoading(userPreferences.status);

  return {
    goals: userPreferences.dashboard.goals || [],
    portfolios: userPreferences.dashboard.portfolios || [],
    loading: loading,
  };
};

const mapDispatchToProps = function (dispatch) {
  return {
    setDashboardGoal: function (goal) {
      dispatch(setDashboardGoal(goal));
    },
    deleteDashboardGoal: function (goalId) {
      dispatch(deleteDashboardGoal(goalId));
    },
    completeGoal: function (goalId) {
      dispatch(completeGoal(goalId));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Goals);
